import { LocationsSitemapWrapper } from './locationSitemapWrapper';

const props = [];

export const LocationSitemapDirective = reactDirective => reactDirective(LocationsSitemapWrapper, props);
LocationSitemapDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('locationsSitemap', LocationSitemapDirective);